import React, { Component } from 'react'
import SideAudioPlayer from "../widgets/SideAudioPlayer.js";
import "./SideNav.css";

import drive_safe from "../audio/Rich Brian - Drive Safe.mp3";
import where_time from "../audio/Rich Brian ft. Joji - Where has the time gone.mp3"
import do_not_disturb from "../audio/Drake - Do Not Disturb.mp3";

export default class SideNav extends Component {
    render() {
        return (
            <div className = "container__sideNav">
                <SideAudioPlayer
                songs = {[
                    {
                        name: "Rich Brian - Drive Safe",
                        audio: drive_safe
                    },
                    {
                        name: "Rich Brian - Where Does the Time Go",
                        audio: where_time
                    },
                    {
                        name: "Drake - Do Not Disturb",
                        audio: do_not_disturb
                    }
                ]}/>

            </div>
        )
    }
}


/*
function SideTab(props)
{

    return (
        <div
            className = {props.class} 
            onClick = {props.event}
            >{props.label}
        </div>
    )
}
*/

/*
function CurrentVentures(props){
    return (
        <div id = "currentVentures">
            <div className = "currentVentures-container">
                <div>&#128050; Currently &#128126;</div>
                <ul className = {"currentVentures-content"}>
                    <li><img src = {graphQL} width = "20px" height = "20px"
                    ></img> Learning Graph QL</li>
                    <li> &#9749; Learning Java</li>
                    <li> &#128163; Practicing Web Secruity</li>
                    <li> &#127891; Third Year Computer Science</li>
                </ul>
            </div>
        </div>
    )
}
*/
